import { render } from "./AppBranding.vue?vue&type=template&id=a8032ca2&scoped=true"
import script from "./AppBranding.vue?vue&type=script&lang=js"
export * from "./AppBranding.vue?vue&type=script&lang=js"

import "./AppBranding.vue?vue&type=style&index=0&id=a8032ca2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8032ca2"]])

export default __exports__